// extracted by mini-css-extract-plugin
export var pillWrapper = "_pi-0";
export var showOverflow = "_pi-1";